function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.33 10.612a.238.238 0 00.34 0L21.91.372a.526.526 0 01.743 0l-.025-.025a.528.528 0 010 .743l-10.24 10.24a.238.238 0 000 .34l10.24 10.24a.526.526 0 010 .743l.025-.025a.528.528 0 01-.743 0l-10.24-10.24a.238.238 0 00-.34 0L1.09 22.628a.526.526 0 01-.743 0l.025.025a.528.528 0 010-.743l10.24-10.24a.238.238 0 000-.34L.372 1.09a.526.526 0 010-.743L.347.372a.528.528 0 01.743 0l10.24 10.24z"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/close.a4b11316.svg";
export { SvgClose as ReactComponent };